export default __webpack_public_path__ + "static/media/graphics-01.b74842c0.png";